import BaseCtrl from 'edge/platform/base/BaseCtrl';
import DateUtil from 'gw-portals-util-js/DateUtil';

var fn = function fn($scope, submissionViewModel) {

    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();
    // This function is used to remove prefill data entered through guidance to product account and submission creation.
    var sanitisePrefillDataFromGuidanceToProduct = function sanitisePrefillDataFromGuidanceToProduct(submission) {
        if (submission.baseData.accountHolder.contactName === '0dummyname0') {
            submission.baseData.accountHolder.contactName = undefined;
            submission.lobData.businessOwners.smallBusinessType = undefined;
            submission.lobData.businessOwners.accountOrgType = undefined;
        }
    };

    ctrl.init = function () {
        $scope.accountHolder = submissionVM.baseData.accountHolder.value;
        sanitisePrefillDataFromGuidanceToProduct(submissionVM.value);
        $scope.accountHolder.primaryPhoneType = null;
        submissionVM.baseData.policyAddress.addressType.value = submissionVM.baseData.policyAddress.addressType.value || 'home';

        $scope.submissionVM = submissionVM;

        $scope.postalCodeReadonly = angular.isDefined($scope.submissionVM.baseData.policyAddress.postalCode.value);
        $scope.stateReadonly = angular.isDefined($scope.submissionVM.baseData.policyAddress.state.value);

        $scope.today = DateUtil.currentDateAtMidnight();
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'submissionViewModel'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/bop/controllers/BOPContactDetailsCtrl.js
// module id = 2105
// module chunks = 0